export default () => ({
    scope: false,
    restrict: 'A',
    link(scope, element, attr) {
        element.css('cursor', 'pointer');
        if (attr.aHref) {
            element.on('click', () => window.location = attr.aHref);
        }
    }
});